"use strict";

import "./VehiclePOICrossingsTimeline.css";
import React from "react";

import dispatcher from "./../../dispatcher";

import vehiclePOICrossingStore from "./../../store/vehiclePOICrossings";

import Card from "vwa/components/Card";
import lang from "vwa/lang";
import EEP from "vfu/EEP";

import {getBoundsOfPOI} from "./../../utils/poi";
import {focusOnVehiclePOICrossing} from "./../../utils/vehiclePOICrossing";

import CrossingCard from "./CrossingCard";

const ALL = Symbol();
const ANY = Symbol();

export default class VehiclePOICrossingsTimeline extends React.Component {
	
	constructor(props){
		super(props);
		this.initState();
		this.eep = new EEP();
		this.setStoreListeners();
	}
	
	initState(){
		this.state = this.getStoreDependentState();
	}
	
	getStoreDependentState() {
		
		const vehiclePOICrossingsDescriptor = vehiclePOICrossingStore.get(this.props.vehicleId);
		
		return {
			from: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.from : null,
			to: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.to : null,
			pois: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.options.poi : [],
			crossings: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.result.crossings : null,
			pinnedCrossings: vehiclePOICrossingsDescriptor ? vehiclePOICrossingsDescriptor.pinnedCrossings : []
		};
	}
		
	setStoreListeners(){
		this.eep.on(vehiclePOICrossingStore, "insert", descriptors => {
			const descriptor = descriptors.find(d => d.vehicle == this.props.vehicleId);
			if (descriptor) {
				this.setState(this.getStoreDependentState());
			}
		});
		this.eep.on(vehiclePOICrossingStore, "update", descriptor => {
			if (descriptor.vehicle == this.props.vehicleId) {
				this.setState(this.getStoreDependentState());
			}
		});
		this.eep.on(vehiclePOICrossingStore, "remove", vehicleIds => {
			if (vehicleIds.find(id => id == this.props.vehicleId))
				this.setState(this.getStoreDependentState());
		});
	}
		
	componentWillUnmount() {
		this.eep.close();
	}
	
	shouldComponentUpdate(_, nextState) {
		if (nextState.from !== this.state.from || nextState.to !== this.state.to) {
			return true;
		}
		if (Object.keys(nextState.pinnedCrossings).some(time => this.state.pinnedCrossings[time] != this.state.pinnedCrossings[time])) {
			return true;
		}
		// A pois állapot egyenes store-on keresztül
		// az api-től jön. Tehát csak akkor változik
		// a referenciája, ha az api új payload-ot hoz.
		if (nextState.pois !== this.state.pois)
			return true;
		return false;
	}
	
	getSectionsCumulativePinnedStatus(how) {
		if (!this.state.pinnedCrossings)
			return;
		
		const times = Object.keys(this.state.pinnedCrossings)
		
		if (how === ALL)
			return times.every(time => this.state.pinnedCrossings[time]);
		else if (how === ANY)
			return times.some(time => this.state.pinnedCrossings[time]);
		
		return false;
	}
	
	handlePinAll(value) {
		if (!this.state.sections)
			return;
		
		dispatcher.dispatch(
			"pinVehicleActivitySection",
			this.props.vehicleId,
			this.state.sections.map((_, i) => i),
			value
		);
	}
	
	handleHighlightAll(value) {
		if (!this.state.sections)
			return;
		
		dispatcher.dispatch(
			"highlightVehicleActivitySection",
			this.props.vehicleId,
			this.state.sections.map((_, i) => i),
			value
		);
	}
	
	focusPOI(poi) {
		dispatcher.dispatch('setMap', {
			bounds: getBoundsOfPOI(poi).toJSON()
		});
	}
	
	renderCrossing(crossing, count) {
		return (
			<div className="Crossing" key={count}>
				<div/>
				<div>
					<CrossingCard
						key={count}
						crossing={crossing}
						onClick={evt => focusOnVehiclePOICrossing(this.props.vehicleId, crossing.time)}
						onPOINameClick={_ => this.focusPOI(crossing.poi)}
						onMouseEnter={() => dispatcher.dispatch("highlightVehiclePOICrossing", this.props.vehicleId, crossing.time, true)}
						onMouseLeave={() => dispatcher.dispatch("unhighlightVehiclePOICrossing", this.props.vehicleId, crossing.time)}
					/>
				</div>
			</div>
		);
	}
	
	renderDaySeparator(dateString, key){		
		return (
			<div className="DateSeparator" key={"timeseparator" + key}>
				<div>
					<label>{dateString}</label>
				</div>
				<div>
					<div className="Dot"/>
				</div>
			</div>
		);
	}
	
	renderCrossings() {
		if (!this.state.crossings || (this.state.crossings && this.state.crossings.length == 0)){
			return null;
		}
		
		const elements = [];
		
		this.state.crossings.forEach((crossing, i) => {
			if(i==0 || (new Date(crossing.time)).getDay() != (new Date(this.state.crossings[i-1].time)).getDay()){
				elements.push(this.renderDaySeparator((new Date(crossing.time)).toLocaleDateString(), i));
			}
			
			elements.push(this.renderCrossing(crossing, i));
		});
		
		return elements;
	}
	
	render(){
		return (
			<div className="VehiclePOICrossingsTimeline">
				<div>
					{this.renderCrossings()}
				</div>
			</div>
		);
	}
	
}

VehiclePOICrossingsTimeline.propTypes = {
	vehicleId: React.PropTypes.string
};

VehiclePOICrossingsTimeline.defaultProps = {
	vehicleId: null
};


// WEBPACK FOOTER //
// ./src/view/VehiclePOICrossingsTimeline/VehiclePOICrossingsTimeline.jsx